import { Link } from 'react-router-dom'

interface PricingSectionProps {
  showHeader?: boolean
}

const plans = [
  {
    tier: 'solo',
    name: 'Solo',
    price: 9,
    description: 'For individuals getting started',
    features: [
      'Voice analysis & AI generation',
      'Content queue & editing',
      'Direct posting to X',
      '~50 posts/month',
    ],
    highlighted: false,
  },
  {
    tier: 'pro',
    name: 'Pro',
    price: 29,
    description: 'For creators who mean business',
    features: [
      'Everything in Solo',
      'Post scheduling',
      'Auto-posting',
      'Analytics dashboard',
      '~200 posts/month',
    ],
    highlighted: true,
    badge: 'Most Popular',
  },
  {
    tier: 'agency',
    name: 'Agency',
    price: 79,
    description: 'For teams and power users',
    features: [
      'Everything in Pro',
      'Multiple X accounts',
      'Priority support',
      'Unlimited posts',
    ],
    highlighted: false,
  },
] as const

export function PricingSection({ showHeader = true }: PricingSectionProps) {
  return (
    <section id="pricing" className="py-20 px-4">
      <div className="max-w-5xl mx-auto">
        {showHeader && (
          <div className="text-center mb-16">
            <h2 className="text-3xl font-medium mb-3">Simple pricing</h2>
            <p className="text-secondary-text">
              Pick a plan. Cancel anytime. No surprises.
            </p>
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {plans.map((plan) => (
            <div
              key={plan.tier}
              className={`border p-6 flex flex-col ${
                plan.highlighted
                  ? 'border-primary-text border-2'
                  : 'border-border'
              }`}
            >
              {plan.highlighted && plan.badge && (
                <span className="text-xs font-medium bg-primary-text text-primary-bg px-2 py-1 self-start mb-4">
                  {plan.badge}
                </span>
              )}
              <h3 className="text-xl font-medium">{plan.name}</h3>
              <p className="text-secondary-text text-sm mt-1">
                {plan.description}
              </p>
              <div className="mt-4 mb-6">
                <span className="text-4xl font-medium">${plan.price}</span>
                <span className="text-secondary-text">/mo</span>
              </div>
              <ul className="space-y-3 mb-8 flex-1">
                {plan.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-2 text-sm">
                    <span className="text-primary-text mt-0.5">&#10003;</span>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              <Link
                to={`/login?tab=register&plan=${plan.tier}`}
                className={`btn text-center text-sm ${
                  plan.highlighted ? 'btn-primary' : 'btn-secondary'
                }`}
              >
                Start free
              </Link>
              <p className="text-xs text-secondary-text text-center mt-2">
                15 free generations, no card needed
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
